<template>
    <v-container class="pa-0 ma-0" fill-height>
        <template v-if="checkupResult">
            <v-row dense class="ma-0 pa-0 px-7">
                <v-col cols="12" align-self="start" class="pa-0 mt-7 report_ov_header">
                    <span class="name">{{name}}</span>님의
                    <p>건강 위험도 분석 결과</p>
                </v-col>
                <v-col cols="12" align-self="start" class="pa-0 report_ov_date">
                    {{issuedDate}}
                </v-col>
            </v-row>

            <v-row dense class="ma-0 mx-7" style="border-top:1px solid #f3f5f7;">
                <v-col cols="4" class="pa-0 pt-4" v-for="(disease, index) in diseaseList" :key="index" align-self="start" align="center">
                    <v-disease-card
                        :disease="disease"
                        :diseaseID="index"
                    />
                </v-col>
            </v-row>

            <v-row dense class="ma-0 px-1 mt-5 mb-16 pb-4">
                <v-col cols="12" class="pa-0" align-self="end" align="center">
                    <v-img :src="require('@/assets/images/renew/banner-selvycheckup-download.png')" width="300" height="74" @click="goToSample"/>
                </v-col>
            </v-row>

            <v-container class="pa-0 ma-0 mt-15 footer_btn_group">
                <v-row class="ma-0 pa-0">
                    <v-col cols="3" class="ma-0 pa-0">
                        <v-btn
                            elevation="0"
                            class="tearms_cancel_btn"
                            block
                            tabindex="8"
                            @click="goToPrev"
                            tile
                            v-ripple
                        >
                            다시
                        </v-btn>
                    </v-col>
                    <v-col cols="9" class="ma-0 pa-0">
                        <v-btn
                            elevation="0"
                            block
                            class='tearms_start_enable_btn'
                            tabindex="9"
                            @click="goToNext"
                            tile
                            v-ripple
                        >
                            결과 분석 가이드 더보기
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </template>
        <template v-else>
            <div class="main-container">
                오류! 셀비체크업 결과를 가져오지 못했습니다.
            </div>
        </template>
    </v-container>
</template>
<script>
    import { mapActions, mapGetters } from "vuex";
    import types from '../../store/types'
    import VDiseaseCard from "@/components/diseaseCard"
    export default {
        name: "reportOverview",
        components: {
            VDiseaseCard,
        },
        data() {
            return {
            }
        },
        computed: {
            ...mapGetters('user', [
                'getUser'
            ]),
            ...mapGetters('survey', [
                'checkupNo',
                'checkupResult',
                'checkUp'
            ]),
            name() {
                return this.checkupResult.name
            },
            issuedDate() {
                //return '발행일 : 2018.06.12'
                return this.checkupResult.displayCheckupDate
            },
            isDBInsurance() {
                if( process.env.VUE_APP_TARGET_COMPANY === 'db-insurance') {
                    return true
                }
                return false
            },
            diseaseList() {
                const diseaseList = [
                    {
                        name: '당뇨병',
                        index: this.checkupResult.dmIndex
                    },
                    {
                        name: '간암',
                        index: this.checkupResult.liverIndex
                    },
                    {
                        name: '대장암',
                        index: this.checkupResult.colorectalIndex
                    },
                    {
                        name: '위암',
                        index: this.checkupResult.stomachIndex
                    },
                    {
                        name: '폐암',
                        index: this.checkupResult.lungIndex
                    },
                    {
                        name: '전립선암',
                        index: this.checkupResult.prostateIndex
                    },
                    {
                        name: '유방암',
                        index: this.checkupResult.breastIndex
                    },
                    {
                        name: '치매',
                        index: this.checkupResult.dementiaIndex
                    },
                    {
                        name: '심장질환',
                        index: this.checkupResult.heartIndex
                    },
                    {
                        name: '뇌졸중',
                        index: this.checkupResult.strokeIndex
                    },
                ]
                if(!this.isDBInsurance) {
                    diseaseList.splice(7, 3)
                }

                let toBeDeleted = -1
                if(this.checkupResult.gender === '1') {
                    toBeDeleted = diseaseList.findIndex(disease => {
                        return (disease.name === '유방암')
                    })
                }
                else if(this.checkupResult.gender === '2') {
                    toBeDeleted = diseaseList.findIndex(disease => {
                        return (disease.name === '전립선암')
                    })
                }
                if(toBeDeleted > -1) {
                    diseaseList.splice(toBeDeleted, 1)
                }
                return diseaseList
            }
        },
        methods: {
            ...mapActions('survey', [
                'getCheckupResult'
            ]),
            goToNext() {
                this.$router.push('/checkup/guideDisease')
            },
            goToSample() {
                this.$router.push('/checkup/reportSample')
            },
            goToPrev() {
                this.$router.push('/userTerms')
            }
        },
        async mounted() {
            window.scrollTo(0, 0)
            if(this.getUser && this.checkupNo) {
                const param = {
                    authToken: this.getUser.authToken,
                    checkupNo: this.checkupNo
                }
                const res = await this.getCheckupResult(param)
                const resultCode = Number(res.data.code)
                if(resultCode === 200) {

                }
                else {
                    console.log('Cannot get checkup result.')
                }
            }
            else {
                console.log('There is no available data.')
            }
        }
    }
</script>
<style scoped>
    .report_ov_header {
        color: #193263;
        font-weight:700;
        font-size:21px;
        line-height:30px;
        letter-spacing: 1px;
    }

    .report_ov_date {
        color: #a3adc1;
        letter-spacing: 0;
        font-size:12px;
        font-weight:700;
    }

    .name {
        font-family: "NanumSquare", sans-serif;
        font-weight: 700;
        font-size: 24px;
        letter-spacing: -1.14px;
        text-decoration: underline #00afef;
    }
    .date {
        margin-bottom: 52px;
    }

    .imgIcon {
        width: 24px;
        height: 24px;
        vertical-align: middle;
    }
    .btn-go-result {
        color: white;
        background-color: #3f6fff;
        width: 100%;
        height: 44px;
        line-height: 44px;
        vertical-align: middle;
        text-align: center;
        font-family: "SpoqaHanSans";
        font-weight: bold;
        border-radius: 22px;
        margin-bottom: 30px;
        box-shadow: 0 8px 20px -4px rgba(63, 111, 255, 0.5);
    }
    .bottom-menu {
        font-family: "SpoqaHansSans";
        font-weight: bold;
        color: #5e5e5e;
    }

	.tearms_cancel_btn {
		height: 60px !important;
		background-color: #dcdfe6 !important;
		color: #193263;
		font-weight: 700;
        font-family: NanumSquare, sans-serif !important;
	}

	.tearms_start_enable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif;
        color: white !important;
		border: 0;
		outline: none;
	}

	.tearms_start_disable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif !important;
        color: white !important;
		border: 0;
		outline: none;
    }

	::v-deep .tearms_start_disable_btn .v-btn__content {
		color: white !important;
	}

	::v-deep .tearms_start_enable_btn .v-btn__content {
		color: white !important;
	}

	.terms_container {
		word-break: keep-all;
        align-items: baseline !important;
    }

	@media screen and (max-height: 759px)
    {   
        .intro_title_img{
            margin-top:0;
        }
    }

</style>
